/** RBAC roles — maps to PRD Section 8.2.1 */
export const UserRole = {
  CUSTOMER: 'customer',
  CORPORATE_ADMIN: 'corporate_admin',
  DRIVER: 'driver',
  CASHIER: 'cashier',
  SUPERVISOR: 'supervisor',
  OPERATIONS_MANAGER: 'operations_manager',
  FINANCE_MANAGER: 'finance_manager',
  QUALITY_CONTROL: 'quality_control',
  ADMIN: 'admin',
  SUPER_ADMIN: 'super_admin',
} as const;

export type UserRole = (typeof UserRole)[keyof typeof UserRole];

/** Roles that get mobile app access (unified app) */
export const MOBILE_ROLES: UserRole[] = [
  UserRole.CUSTOMER,
  UserRole.DRIVER,
  UserRole.OPERATIONS_MANAGER,
  UserRole.SUPERVISOR,
  UserRole.QUALITY_CONTROL,
  UserRole.SUPER_ADMIN,
  UserRole.ADMIN,
];

/** Roles that get web admin dashboard access */
export const ADMIN_DASHBOARD_ROLES: UserRole[] = [
  UserRole.CASHIER,
  UserRole.SUPERVISOR,
  UserRole.OPERATIONS_MANAGER,
  UserRole.FINANCE_MANAGER,
  UserRole.QUALITY_CONTROL,
  UserRole.ADMIN,
  UserRole.SUPER_ADMIN,
];

/** Roles that get POS access */
export const POS_ROLES: UserRole[] = [
  UserRole.CASHIER,
  UserRole.SUPERVISOR,
  UserRole.ADMIN,
  UserRole.SUPER_ADMIN,
];
